import React from "react";

export function NoAccess(){
    return<>
    You Have No Access.
    </>
}